import { render, staticRenderFns } from "./WebGL.vue?vue&type=template&id=19d35414&scoped=true&"
import script from "./WebGL.vue?vue&type=script&lang=js&"
export * from "./WebGL.vue?vue&type=script&lang=js&"
import style0 from "./WebGL.vue?vue&type=style&index=0&id=19d35414&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d35414",
  null
  
)

export default component.exports